import { METHOD } from "./method";

export const API_HAPPINESS_INDEX = {
    LIST: {
        api: '/v1/hr-adm/hr-metrics/happiness-index',
        method: METHOD.GET
    },
    DETAIL: {
        api: '/v1/hr-adm/hr-metrics/happiness-index',
        method: METHOD.GET
    },
    EXPORT: {
        api: '/v1/hr-adm/hr-metrics/happiness-index/export',
        method: METHOD.POST
    },
    CREATE_PERIOD: {
        api: '/v1/hr-adm/hr-metrics/happiness-index/periods',
        method: METHOD.POST
    },
    DELETE_PERIOD: {
        api: '/v1/hr-adm/hr-metrics/happiness-index/periods',
        method: METHOD.DELETE
    },

    UPDATE: {
        api: '/v1/hr-adm/hr-metrics/happiness-index',
        method: METHOD.PUT
    },
    DELETE: {
        api: '/v1/hr-adm/hr-metrics/happiness-index',
        method: METHOD.DELETE
    },
    SUBMIT: {
        api: '/v1/hr-adm/hr-metrics/happiness-index/submit',
        method: METHOD.POST
    },

    DOWNLOAD_TEMPLATE: {
        api: '/v1/hr-adm/hr-metrics/happiness-index/import/download-template',
        method: METHOD.POST
    },
    FILE_VALIDATION: {
        api: '/v1/hr-adm/hr-metrics/happiness-index/import/validate',
        method: METHOD.POST
    },
    IMPORT: {
        api: '/v1/hr-adm/hr-metrics/happiness-index/import/process',
        method: METHOD.POST
    },
}